'use client';

import type { DncResponse } from '@hc-frontend/services';
import { useState } from 'react';

import { Unsubscribe } from './unsubscribe';
import { UnsubscribeResult } from './unsubscribe-result';

export function UnsubscribeForm({
  isAdmin,
  email,
}: {
  isAdmin: boolean;
  email: string | null;
}) {
  const [dncResponse, setDncResponse] = useState<DncResponse | undefined>(
    undefined,
  );

  return dncResponse ? (
    <UnsubscribeResult dncResponse={dncResponse} />
  ) : (
    <Unsubscribe
      isAdmin={isAdmin}
      email={email}
      setDncResponse={setDncResponse}
    />
  );
}
